import BaseComponent from '@/components/base';
import HairGoals from '@/components/quiz/hail-goals';
import Fragrances from '@/components/quiz/fragrances';
import HairType from '@/components/quiz/hair-type';

export default class Quiz extends BaseComponent {
  onConstruct() {
    customElements.define('hair-goals', HairGoals);
    customElements.define('hair-type', HairType);
    customElements.define('fragrances-component', Fragrances);

    const container = document.querySelector(
      '.product-core-inner.product-core-inner--main'
    );
    container && (container.style.overflowY = 'auto');
  }

  render() {
    return `

    <div>
        <hair-goals></hair-goals>
        <hair-type></hair-type>
        <fragrances-component></fragrances-component>
    </div>

    `;
  }

  get fragranceComponent() {
    return this.shadowRoot.querySelector('fragrances-component');
  }

  get hairGoalsComponent() {
    return this.shadowRoot.querySelector('hair-goals');
  }

  get hairTypeComponent() {
    return this.shadowRoot.querySelector('hair-type');
  }

  get fragrance() {
    return this.shadowRoot
      .querySelector('fragrances-component')
      .getAttribute('value');
  }

  get hairGoals() {
    const stringValue =
      this.shadowRoot.querySelector('hair-goals').getAttribute('value') ?? '[]';

    const objectValue = JSON.parse(stringValue);
    return objectValue;
  }

  get hairType() {
    return this.hairTypeComponent.getAttribute('value');
  }
}
